// ScheduleDepositionListItem

import { ScheduleDepositionListItem } from 'src/redux/scheduleDepositionRedux/types';
import { DateFormatDisplay, getDateDisplay, getTimeDisplay, TimeFormat12 } from 'src/utils/momentUtils';

export const rawDataToScheduleDepositionListItem = (schedDepos: ScheduleDepositionListItem[]) => {
  return schedDepos.map(depo => ({
    id: depo.id,
    name: depo.name,
    lawFirm: depo.lawFirm,
    attorneyName: depo.attorneyName,
    depositionLocation: depo.depositionLocation,
    isNeedConferenceRoom: depo.isNeedConferenceRoom,
    deponent: depo.deponent,
    email: depo.email,
    phoneNumber: depo.phoneNumber,
    city: depo.city,
    caseName: depo.caseName,
    additionalNotes: depo.additionalNotes,
    depositionDate: getDateDisplay(depo.depositionDate, DateFormatDisplay),
    depositionTime: getTimeDisplay(depo.depositionDate, TimeFormat12),
    depositionFullDate: depo.depositionDate,
    uri: depo.uri,
  }));
};
